import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import { SavingsAccountCard } from '@/components/BankCard';
import useFavouriteDeposits from '@/hooks/useFavouriteDeposits';
import type { IBankDepositCard } from '@/types';
import { cn } from '@/utils';

interface DepositCardsProps {
  isLoading: boolean;
  onLoadMore: () => void;
  // isFavorited: (bank: IBankDepositCard) => boolean;
  deposits: IBankDepositCard[];
  shouldLoadMore?: boolean;
  className?: string;
}

export const SavingsAccountsCards: FC<DepositCardsProps> = ({
  deposits,
  isLoading,
  onLoadMore,
  shouldLoadMore = true,
  className,
  // isFavorited,
}) => {
  const { t } = useTranslation();

  const { handleFavourite, checkIsFavorite } = useFavouriteDeposits();

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center pb-20',
        className,
      )}
    >
      <div className="mt-4 flex w-full flex-col gap-4 space-y-3">
        {deposits.map((bank) => (
          <SavingsAccountCard
            key={`all_deposits_${bank.productIndex}`}
            bank={bank}
            isFavourite={checkIsFavorite(bank)}
            handleFavourite={() => handleFavourite(bank)}
          />
        ))}
      </div>
      {shouldLoadMore && (
        <button
          type="button"
          onClick={onLoadMore}
          disabled={isLoading}
          className="btn-blue-states mt-4 rounded-full px-8 py-2 disabled:bg-grey-300"
        >
          {isLoading ? t('global.loading') : t('global.load_more')}
        </button>
      )}
    </div>
  );
};
